module.exports = __webpack_public_path__ + "static/pinkmummymemain-f38326ee6073e2f0c53e85fe35756bf8.png";